"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

// Inline Material-style "trending up" glyph — line chart going up-right with an
// arrow head. Inlined (vs. a shared icon file) because it's only used here.
var TrendingUpIcon = function TrendingUpIcon() {
  return (0, _preact.h)("svg", {
    className: "live-search-suggested-questions__try-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, (0, _preact.h)("path", {
    d: "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
  }));
};

var SuggestedQuestionsRow = function SuggestedQuestionsRow(_ref) {
  var questions = _ref.questions,
      _ref$centered = _ref.centered,
      centered = _ref$centered === void 0 ? true : _ref$centered;

  if (!questions || questions.length === 0) {
    return null;
  }

  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('live-search-suggested-questions', {
      'live-search-suggested-questions--left': !centered
    }),
    role: "list"
  }, (0, _preact.h)("span", {
    className: "live-search-suggested-questions__try",
    "aria-hidden": "true"
  }, (0, _preact.h)(TrendingUpIcon, null), (0, _preact.h)("span", {
    className: "live-search-suggested-questions__try-label"
  }, "Try:")), questions.map(function (question, index) {
    return (// Composite key so identical question strings (allowed by the backend)
      // don't trigger React's duplicate-key warning or lose a node on re-render.
      (0, _preact.h)("a", {
        key: "".concat(index, "-").concat(question),
        href: (0, _absoluteUrlRuntime.resolveUrl)("/search?q=".concat(encodeURIComponent(question))),
        className: "live-search-suggested-questions__item",
        role: "listitem",
        title: question
      }, (0, _preact.h)("span", {
        className: "live-search-suggested-questions__text"
      }, question))
    );
  }));
};

var _default = SuggestedQuestionsRow;
exports.default = _default;